import { useEffect, useState } from 'react';

import { useSidebarSummaryContext } from '../../../../SidebarSummary.context';
import { ErrorRankingAnimation } from './components/ErrorRankingAnimation/ErrorRankingAnimation';
import { SuccessRankingAnimation } from './components/SuccessRankingAnimation/SuccessRankingAnimation';

export interface RankingAnimationProps {
  hideAnimation?: boolean;
  onAnimationEnd: () => void;
  isFullWidthActive?: boolean;
}

export const RankingAnimation = ({
  hideAnimation,
  onAnimationEnd,
  isFullWidthActive,
}: RankingAnimationProps) => {
  const { selectedQuestion } = useSidebarSummaryContext();
  const [animationEnded, setAnimationEnded] = useState(false);

  const handleAnimationEnd = () => {
    setAnimationEnded(true);
  };

  useEffect(() => {
    if (animationEnded && hideAnimation) {
      onAnimationEnd();
    }
  }, [hideAnimation, animationEnded, onAnimationEnd]);

  return selectedQuestion?.isCorrect ? (
    <SuccessRankingAnimation
      isFullWidthActive={isFullWidthActive}
      hideAnimation={hideAnimation}
      onAnimationEnd={handleAnimationEnd}
    />
  ) : (
    <ErrorRankingAnimation
      hideAnimation={hideAnimation}
      onAnimationEnd={handleAnimationEnd}
    />
  );
};
